import { MonthPicker } from '@/components/shared/date/MonthPicker';
import { getMonthBounds } from '@/helpers/dateHelper';
import { format } from 'date-fns';
import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Card } from '../../../../components/shared/card/Card';
import { SummaryEmployee } from '../../../../services/summary/summary.types';
import { useSummary } from '../../../../services/summary/useSummaryService';
import { strings } from '../../../../services/translation/strings';
import { TeamMemberAnnualLeaveCard } from './TeamMemberAnnualLeaveCard';
import { TeamMemberTimeWorkedCard } from './TeamMemberTimeWorkedCard';
import { Feature } from '@/services/backstage/Feature';

interface TeamMemberStatsProps {
  selectedDate: Date;
  setSelectedDate: (newDate: Date) => void;
}

export const statsSectionId = 'statsSectionId';

export const TeamMemberStats: FC<TeamMemberStatsProps> = ({ setSelectedDate, selectedDate }) => {
  const { userId } = useParams<'userId'>();

  const [startDate, endDate] = useMemo(() => {
    return getMonthBounds(selectedDate);
  }, [selectedDate]);

  const { allEmployeesSummary: summary } = useSummary(startDate, endDate);
  const summaryEmployee = summary?.find((e: SummaryEmployee) => e.id === userId);
  const dateString = format(startDate, 'MMMM yyyy');

  if (!summaryEmployee || !summaryEmployee.schedule) {
    return (
      <section id={statsSectionId}>
        <Card className="bg-white p-4 text-center">{strings.timeshift.teamMember.scheduleNotFound}</Card>
      </section>
    );
  }
  const thisMonthsSchedule = summaryEmployee.schedule.filter(
    day => new Date(day.date).getMonth() === startDate.getUTCMonth()
  );

  return (
    <section id={statsSectionId} className="flex flex-col gap-4">
      <MonthPicker value={selectedDate} onChange={setSelectedDate} />
      <Feature name="roster">
        <TeamMemberTimeWorkedCard dateString={dateString} employeeSchedule={thisMonthsSchedule} />
        <TeamMemberAnnualLeaveCard dateString={dateString} employeeSchedule={thisMonthsSchedule} />
      </Feature>
    </section>
  );
};
